import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {CookieHelper} from '../helpers/cookie.helper';
import {specialHideWelcomePage} from "../const/utils";
import {ROUTES_PATHS} from "../const/routes";

@Component({
	selector: 'app-welcome',
	templateUrl: './welcome.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./welcome.component.less']
})
export class WelcomeComponent implements OnInit {
	textes: any;
	globalTxt: any;
	outOfSimu: boolean = false;
	token = JSON.parse(localStorage.getItem("token")!);
	byPassWelcome = this.cookieHelper.getCookie(this.cookieHelper.cookieByPassWelcomeName) === 'true';

	constructor(
		public app: AppComponent,
		private cookieHelper: CookieHelper
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// If the user has already bypassed the welcome page, redirect to the address selection page
		// Or if the user is on a special path that should not show the welcome page
		if (this.byPassWelcome || specialHideWelcomePage.includes(this.app.sharedToolsService.returnObjectSwitchRefId())) {
			// if this.byPassWelcome is false, create cookie
			if (!this.byPassWelcome) {
				this.cookieHelper.setCookie(this.cookieHelper.cookieByPassWelcomeName, 'true', 365);
			}

			// If the user has already bypassed the welcome page, redirect to the home page
			this.app.router.navigate([ROUTES_PATHS.CHOIX_RENOV]);
			return;
		}

		// Check if the user is logged in and has simulations
		this.token = JSON.parse(localStorage.getItem("token")!);
		this.outOfSimu = (this.token && this.token?.outOfSimu) ? this.token.outOfSimu : false;

		// Clear localStorage items related to modals and estimations
		let currentModal = JSON.parse(localStorage.getItem("modalOpen")!);
		if (currentModal) localStorage.removeItem('modalOpen');
		let estimation = JSON.parse(localStorage.getItem("estimation")!);
		if (estimation) localStorage.removeItem('estimation');

		// Initialize user data and settings
		this.app.sharedToolsService.getUsrByID();

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	// bypassé la page Welecome stockage dans cookie
	checkCheckBoxvalue(event: any) {
		if (event.target.checked) {
			this.cookieHelper.setCookie(this.cookieHelper.cookieByPassWelcomeName, 'true', 365);
		} else {
			this.cookieHelper.deleteCookie(this.cookieHelper.cookieByPassWelcomeName);
		}
	}

	getInfosInit(_nameJson: any) {
		// Get the settings
		this.app.sharedToolsService.getSettings();

		this.app.sharedToolsService.loadTexts(_nameJson)
			.subscribe(textes => {
				this.textes = textes;
				console.log("getInfosInit textes ==> ", this.textes);

				// Get the global texts
				this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
					this.globalTxt = globalTxt;
					console.log("getInfosInit globalTxt ==> ", this.globalTxt);
				})
			})
	}

	public readonly ROUTES_PATHS = ROUTES_PATHS;
}
